/**
 * This is the add jobb page and is accessed by going to "/job/{slug}".
 */
import JobiqoJobPage, { getServerSideProps } from '~/jobiqo/pages/job/detail';
export default JobiqoJobPage;
export { getServerSideProps };
